module.exports = __webpack_public_path__ + "media/application/images/logo-eu-70fb7dfd048acffb19f35a5ecf0b7139.svg";